module.exports = __webpack_public_path__ + "img/adapt-arr-act.4411e6df.svg";